// Libraries
import 'bootstrap';

import './Components/BrowserBackClass';
import './Components/HeaderClass';
import './Components/OffcanvasClass';
import './Components/SliderClass';
import './Components/ScrollToClass';
import './Components/ParallaxClass';
import './Components/LightboxClass';
import './Components/TableLimiterClass';
import './Components/ImageGalleryClass';
import './Components/ShowMoreContainerClass';
import {ShowMoreContainer} from "./Components/ShowMoreContainerClass";
import './Components/AccordionClass';
import './Components/CounterClass';
import './Components/TabsClass';
import './Components/ImageCompareClass';
import './Components/IntroTeaserVideo';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll<HTMLElement>('[data-show-more-container]').forEach(showMoreContainer => {
    new ShowMoreContainer(showMoreContainer);
  });
});
